import * as React from "react";
import { GiCarWheel, GiCarBattery } from "react-icons/gi";
import { FaWrench } from "react-icons/fa";
import { FaCarBurst, FaGear, FaCarOn } from "react-icons/fa6";

const iconSize = 40;

export const cardData = [
  { icon: <GiCarWheel size={iconSize} />, text: "Brakes" },
  {
    icon: <GiCarBattery size={iconSize} />,
    text: "Alternator and Battery Testing",
  },
  { icon: <FaGear size={iconSize} />, text: "Check Engine Light" },
  { icon: <FaCarOn size={iconSize} />, text: "Electrical Trouble Shooting" },
  { icon: <FaWrench size={iconSize} />, text: "Tune-ups" },
  { icon: <FaCarBurst size={iconSize} />, text: "Suspension" },
];
